import styled from 'styled-components';
import { useMemo } from 'react';
import { Side } from '@paradigm/features/src/unified-rfqs/entities/shared';

import { useQuoteBuilderModalMethods } from '@paradigm/features/src/unified-rfqs/ui/drfq/quote-builder/modal-context';
import { useDrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import {
  paradigmLightBlue,
  pickledBluewood,
} from '@paradigm/design-system/src/colors';
import { useUMPlatformCreationDisabled } from '@paradigm/features/src/platform-state/contexts/providers';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { stopPropagation } from './common';

interface Props {
  readonly side: Side | null;
}

export default function QuoteDrfqButton({ side }: Props) {
  const { open } = useQuoteBuilderModalMethods();
  const isPlatformCreationDisabled = useUMPlatformCreationDisabled();
  const drfq = useDrfqRfq();
  const track = useTrackAction();

  const handleClick = useMemo(() => {
    return stopPropagation(() => {
      track('view quote builder', { auctionType: 'RFQ' });
      open({ rfqId: drfq.id, side });
    });
  }, [drfq.id, open, side, track]);

  return (
    <QuoteButton disabled={isPlatformCreationDisabled} onClick={handleClick} />
  );
}

const QuoteButton = styled.button.attrs({ children: 'Quote' })`
  width: 48px;
  height: 22px;
  font-size: 12px;
  color: ${paradigmLightBlue};
  background-color: ${pickledBluewood};
  border: 0;
  border-radius: 16px;

  &:disabled {
    opacity: 0.5;
  }
`;
